// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M5 12L10.25 17.25V6.75L5 12Z M12 12L17.25 17.25V6.75L12 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"backward"},"children":[{"tag":"g","attrs":{"id":"fill1","mask":"props.overlapMaskUrl_fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 12L10.25 17.25V6.75L5 12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 12L17.25 17.25V6.75L12 12Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M5 12L10.25 17.25V6.75L5 12Z M12 12L17.25 17.25V6.75L12 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const BackwardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'backward',
    ref,
    icon: element,
  },
));

BackwardIcon.displayName = 'BackwardIcon';

export default BackwardIcon;
